import querystring from 'query-string';

import ERRCODE from '../../../constant/errorCode';
import myUtil from '../../util';

import toast from './components/toast';
import { iFingerprint } from '../../../constant/sdk';

class BaseAdapter {
  constructor(sdk) {
    this.sdk = sdk || null;
    this.platform = 'unknown';
  }

  static canUse() {
    return Promise.resolve(true);
  }

  static get util() {
    return myUtil;
  }

  static load() {
    return Promise.resolve();
  }

  config() {
    return Promise.resolve();
  }

  _execSDK(method, args) {
    const { sdk, argsPretreat } = this;
    if (sdk === null) {
      return args.fail({
        ...ERRCODE.NO_SDK
      });
    }

    if (typeof sdk[method] !== 'function') {
      return args.fail({
        ...ERRCODE.NO_API
      });
    }

    let finalArgs = args;
    // 增加通用参数处理接口
    if (myUtil.isFunc(argsPretreat)) {
      finalArgs = argsPretreat(args);
    }
    sdk[method](finalArgs);
  }

  /**
   * 跳转 WebView
   * @param {*} opts 通用传入参数
   */
  openWebview(opts) {
    const { url, qs, fail, windowOpen } = opts;
    if (typeof url !== 'string') {
      return fail('Invaild url');
    }

    if (this.sdk && myUtil.isFunc(this.sdk.openWebview)) {
      return this._execSDK('openWebview', opts);
    }

    const query = querystring.stringify(qs);
    const finalUrl = query ? `${url}?${query}` : url;
    if (windowOpen && myUtil.isFunc(window.open)) {
      window.open(finalUrl);
      return;
    }
    window.location.href = finalUrl;
  }

  /**
   * 跳转 WebView
   * @param {*} opts 通用传入参数
   */
  openPage(opts) {
    const { url, query, qs, fail, windowOpen } = opts;
    if (typeof url !== 'string') {
      return fail('Invaild url');
    }

    if (this.sdk && myUtil.isFunc(this.sdk.openPage)) {
      return this._execSDK('openPage', opts);
    }

    const qsString = querystring.stringify(qs || query);
    const finalUrl = qsString ? `${url}?${qsString}` : url;
    if (windowOpen && myUtil.isFunc(window.open)) {
      window.open(finalUrl);
      return;
    }
    window.location.href = finalUrl;
  }

  toast(opts) {
    if (!opts.content) {
      return;
    }

    if (this.sdk && myUtil.isFunc(this.sdk.toast)) {
      return this._execSDK('toast', opts);
    }

    const duration = opts.duration ? 3500 : 2000;
    toast(opts.content, duration);
    opts.success();
  }

  getUA(opts) {
    myUtil.getUA(opts);
  }

  getFingerprint(opts) {
    myUtil.injectScript(`
      window.Rohr_Opt = {
        geo: false
      };
    `);
    myUtil.loadSDK(iFingerprint.version.latest).then(ret => {
      if (window.Rohr_Opt) {
        const url = location.href;
        const fingerprint = window.Rohr_Opt.reload(url);
        opts.success({
          fingerprint
        });
      } else {
        opts.fail(new Error('获取指纹失败'));
      }
    }).catch(err => {
      opts.fail(err);
    });
  }
}

export default BaseAdapter;
